<template>
  <!-- 顶部操作 搜索 组件 author: zhangxiaofeng -->
  <form class="operation-search" :class="showGroup ? 'operation-search-group' : ''" @submit="submit($event)">
    <div class="f-cb" :class="showGroup ? 'group-search-box':''">
      <!--<div class="group-search-select"  v-if="showGroup" @mouseenter="groupSelListShow = true" @mouseleave="groupSelListShow = false" :class="groupSelListShow ? 'group-search-show' : ''">-->
        <!--<div class="group-search-select-text"><span>{{groupType == 1 ? '名称或项目特征' : '标签'}}</span><b></b></div>-->
        <!--<div class="group-search-sellist" v-show="groupSelListShow" @click="sellistTap">{{groupType == 1 ? '标签' : '名称或项目特征'}}</div>-->
      <!--</div>-->
      <div class="group-search-select" v-if="showGroup">
        <w-select class="inline-block" size="small" v-model="groupType" placeholder="请选择搜索类型" @change="sellistTap">
          <w-option label="名称或项目特征" :value="1"></w-option>
          <w-option label="标签" :value="2"></w-option>
        </w-select>
      </div>
      <div class="search-cntbox">
        <w-input
          style="width: 220px;"
          size="small"
          :placeholder="placeholder"
          v-model.trim="name"
          @enter="triggerSearch($event)">
          <i slot="prefix" class="r2-icon-action_search" style="fontSize: 20px!important; lineHeight: 32px;"></i>
          <i
            v-if="name !== ''"
            class="r2-icon-nav_cancel cursor-pointer"
            style="lineHeight: 32px;"
            slot="suffix"
            @click="name = '';submit()">
          </i>
        </w-input>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  name: 'OperationSearch',
  props: {
    defaultInput: { // 初始时 输入框默认填入的值
      type: String,
      default: ''
    },
    clearSearch: { // 清空输入时 是否触发搜索 默认true: 触发
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请输入名称'
    },
    showGroup: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      groupType: 1,
      groupSelListShow: false,
      name: ''
    }
  },
  created () {
    this.name = this.defaultInput
    // console.log(this.clearSearch)
  },
  methods: {
    triggerSearch (e) {
      if (this.showGroup) {
        // 为何 有下拉选择框时 输入框回车 不提交表单了
        // w-input enter事件 e 是input的值 ！ 不是event ！
        this.submit()
      }
    },
    submit (e) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      // console.log(this.name)
      this.$emit('onSearch', this.name)
    },
    clear () {
      this.clearSearchValue()
      this.clearSearch && this.submit()
    },
    clearSearchValue () {
      this.name = ''
    },
    sellistTap (){
      // this.groupSelListShow = false
      // this.groupType = +this.groupType === 1 ? 2 : 1
      this.$emit('groupTypeChange', this.groupType)
    }
  }
}
</script>

<style lang="less" type="text/less" scoped>
  .operation-search{
    .search-cntbox {
      display: inline-block;
    }
    /*.search-cntbox{*/
      /*position: relative;*/
    /*}*/
    /*&>div{*/
      /*border: 1px solid #ccc;*/
      /*border-radius: 4px;*/
      /*height: 27px;*/
      /*line-height: 27px;*/
      /*position: relative;*/
      /*font-size: 12px;*/
      /*i{*/
        /*margin-left: 4px;*/
        /*position: absolute;*/
        /*left: 0;*/
      /*}*/
      /*input{*/
        /*width: 185px;*/
        /*height: 16px;*/
        /*line-height: 16px;*/
        /*margin-top: 6px;*/
        /*padding-left: 22px;*/
        /*padding-right: 22px;*/
        /*box-sizing: border-box;*/
        /*border: none;*/
        /*outline: none;*/
        /*color: rgb(51, 51, 51);*/
      /*}*/
      /*.w-icon-sousuo{*/
        /*font-size: 14px;*/
        /*color: #ccc;*/
      /*}*/
      /*.w-icon-guanbi{*/
        /*font-size: 12px;*/
        /*cursor: pointer;*/
        /*right: 60px;*/
        /*left: auto;*/
        /*color: #333;*/
      /*}*/
      /*button{*/
        /*cursor: pointer;*/
        /*height: 27px;*/
        /*line-height: 30px;*/
        /*box-shadow: inset 0 1px 0 rgba(255,255,255,0.5), 0 0 0 rgba(0,0,0,0.2);*/
        /*background-color: #eee;*/
        /*background: -webkit-linear-gradient(top, #fbfbfb, #ddd);*/
        /*color: #666;*/
        /*outline: none;*/
        /*border-style: none;*/
        /*width: 50px;*/
        /*border-left: 1px solid #ccc;*/
        /*padding: 0 10px;*/
      /*}*/
    /*}*/
    .group-search-box {
        padding-left: 150px;
        position: relative;
    }
    .group-search-select{
      width: 144px;
      display: inline-block;
      margin-right: 10px;
      /*position: absolute;*/
      /*top:0px;*/
      /*left:0px;*/
    }
    .group-search-select-text{
      text-align: center;
      color: #868686;
      position: relative;
      padding-right:15px;
      cursor: pointer;
    }
    .group-search-select-text b{
      display: inline-block;
      width:10px;
      height:6px;
      background: url("~@/assets/images/search-select-icon01.png")  no-repeat;
      position: absolute;
      right:5px;
      top:11px;
    }
    .group-search-sellist{
      border:1px solid #cccccc;
      border-top:1px solid #fff;
      text-align: center;
      height:28px;
      line-height:28px;
      width:112px;
      position: absolute;
      top: 24px;
      left: -1px;
      background: #fff;
      cursor: pointer;
      z-index: 300;
      color: #868686;
    }
    .group-search-sellist:hover{
      background: #ebebeb;
      color: #6a9dd6;
    }
    .group-search-show .group-search-select-text b{
      background: url("~@/assets/images/search-select-icon02.png")  no-repeat;

    }
    &.operation-search-group{
      input{
        padding-left: 0px;
      }
    }
  }
</style>
